import { useTranslation } from 'react-i18next';

import { ClientPortalChecks_CheckInterface } from '@dotfile/shared/data-access-client-portal';
import {
  CheckDataType,
  DEFAULT_CUSTOM_DOCUMENT_TYPES_TRANSLATED_LABEL,
  formatCheckTitle as domainFormatCheckTitle,
} from '@dotfile/shared/domain';

import { getCheckTranslationKey } from '../utils';

export const useTranslatedCheckTitle = (
  check: ClientPortalChecks_CheckInterface,
): string => {
  const { t, i18n } = useTranslation();

  const { checkTranslationKey, documentTypeKey } =
    getCheckTranslationKey(check);

  let defaultValue = domainFormatCheckTitle(
    check.type,
    check.data as CheckDataType<typeof check.type>,
    {
      t,
      ignorePrefixForDocument: true,
    },
  );

  if (documentTypeKey) {
    const documentTypeTranslation =
      i18n.language in DEFAULT_CUSTOM_DOCUMENT_TYPES_TRANSLATED_LABEL &&
      documentTypeKey in
        DEFAULT_CUSTOM_DOCUMENT_TYPES_TRANSLATED_LABEL[i18n.language]
        ? DEFAULT_CUSTOM_DOCUMENT_TYPES_TRANSLATED_LABEL[i18n.language][
            documentTypeKey
          ]
        : null;

    if (documentTypeTranslation) {
      defaultValue = documentTypeTranslation;
    }
  }

  const translatedCheckTitle = t(`${checkTranslationKey}.label`, {
    ns: 'dynamic',
    defaultValue,
  });

  return translatedCheckTitle;
};
